import { randomAlphaNumeric } from '@/utils/string.js'
/**
 * The `useId()` composable is now Vue native since version 3.5.0
 * https://github.com/vuejs/core/pull/11404
 * and Nuxt has also updated its code to use it
 * https://github.com/nuxt/nuxt/pull/28285
 *
 * With the new updates we now get a typescript check error.
 * The `useId()` composable returns `string | undefined`, which breaks our project in
 * some places where IDs are required.
 * Issue reported here: https://github.com/vuejs/core/pull/11404#issuecomment-2331690052
 *
 * The composable below is a workaround but follows a similar approach than the native one
 */
export function useSafeId(): string {
  let id = useId()

  if (!id) {
    const currentInstance = getCurrentInstance()
    const randomId = randomAlphaNumeric(8)
    id = `${currentInstance?.appContext.config.idPrefix || 'pcloud'}-${randomId}`
  }

  return id
}
